import { useMemo } from "react";

import { useRefDimensions } from "@/app/hooks";

const useBottomDrawerDimensions = ({
  contentRef,
  overlayRef,
  headerRef,
  footerRef,
}: {
  contentRef: HTMLElement | null;
  overlayRef: HTMLElement | null;
  headerRef: HTMLElement | null;
  footerRef: HTMLElement | null;
}) => {
  const _overlayRef = useMemo(() => ({ current: overlayRef }), [overlayRef]);
  const _headerRef = useMemo(() => ({ current: headerRef }), [headerRef]);
  const _footerRef = useMemo(() => ({ current: footerRef }), [footerRef]);
  const _contentRef = useMemo(() => ({ current: contentRef }), [contentRef]);

  // Dimensions
  const { height: contentHeight } = useRefDimensions(_contentRef);
  const { height: overlayHeight } = useRefDimensions(_overlayRef);
  const { height: headerHeight } = useRefDimensions(_headerRef);
  const { height: footerHeight } = useRefDimensions(_footerRef);

  return { contentHeight, footerHeight, headerHeight, overlayHeight };
};

export default useBottomDrawerDimensions;
